import ajax from '../utils/request'
const videoApi = {
  /********************************审核视频相关接口*********************************** */
  getVideoList(params) {
    return ajax({
      url: '/creator/video',
      type: 'get',
      params: params
    })
  },
  detectImageType(bytes) {
    if (bytes[0] === 0xff && bytes[1] === 0xd8) {
      return { type: "image/jpeg", ext: "jpg" };
    }
    if (bytes[0] === 0x89 && bytes[1] === 0x50) {
      return { type: "image/png", ext: "png" };
    }
    if (bytes[0] === 0x47 && bytes[1] === 0x49) {
      return { type: "image/gif", ext: "gif" };
    }
    if (
      bytes[0] === 0x52 &&
      bytes[1] === 0x49 &&
      bytes[8] === 0x57 &&
      bytes[9] === 0x45
    ) {
      return { type: "image/webp", ext: "webp" };
    }
    return { type: "image/png", ext: "png" };
  },
  async imgDecyptApi(url) {
    const encoder = new TextEncoder();
    const KEY = encoder.encode("2019ysapp7527");
    return new Promise((resolve, reject) => {
      const oReq = new XMLHttpRequest();
      oReq.open("GET", url, true);
      oReq.responseType = "arraybuffer";
      oReq.onload = function () {
        const arrayBuffer = oReq.response;
        if (!arrayBuffer) {
          reject(new Error("图片加载失败"));
          return;
        }
        const bytes = new Uint8Array(arrayBuffer);
        for (let i = 0; i < 100; i++) {
          bytes[i] ^= KEY[i % KEY.length];
        }
        const imageType = videoApi.detectImageType(bytes);
        const blob = new Blob([bytes], { type: imageType.type });
        resolve({
          url: URL.createObjectURL(blob),
          blob,
          ext: imageType.ext,
        });
      };
      oReq.onerror = function () {
        reject(new Error("图片请求失败"));
      };
      oReq.send("");
    }).catch((error) => {
      console.log("解密失败", error);
      throw error;
    });
  },
}
export default videoApi